/**
 * Scrolling Effects JS.
 *
 */
($ => {
  Drupal.behaviors.scrollingEffects = {
    attach(context) {
      const $scrollInComponent = $('.js-scroll-in', context);
      const $progressOnePage = $('.page-node-type-progress-one-page');
      if (!$scrollInComponent.length || !$progressOnePage.length) {
        return false;
      }

      $scrollInComponent.each((index, component) => {
        let $component = $(component, context);
        let topOfElement = $component.offset().top;
        let bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();

        $component.addClass('scroll-in');

        if (bottomOfScreen > topOfElement) {
          $component.addClass('scroll-in--scrolled-to');
        }

        if ($(window).width() > 760) {
          $(window).on('scroll', () => {
            // Add class
            $component = $(component, context);
            topOfElement = $component.offset().top;
            bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
            if (bottomOfScreen > topOfElement) {
              setTimeout(() => {
                $component.addClass('scroll-in--scrolled-to');
              }, 250);
            }
            if ($(window).scrollTop() > 140){
              $('.page-header').addClass('sticky');
            }
            else{
              $('.page-header').removeClass('sticky');
            }
          });
        }
      });
    },
  };
})(jQuery);

